import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import LabelWrapper from "components/Common/LabelWrapper";
import {
  COLOR_RESERVATION_USER_TYPE,
  COLOR_VOC_TYPE,
  LIST_VOC_TYPE_OPTION,
  RESERVATION_USER_TYPE,
} from "helpers/constans";
import CountUp from "react-countup";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";
import CollapseFilter from "components/Common/CollapseFilter";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import moment from "moment";
import DatePickerCustom from "components/Common/DatePickerCustom";
import { getVOCList } from "store/voc-list/thunk";
import NO_IMAGE_USER from "../../../assets/images/no-user.png";
import CopyWrapper from "components/Common/CopyWrapper";
import { truncate } from "utils";
import ModalPreview from "components/Common/ModalPreview";
import CollapseContent from "components/Common/CollapseContent";
import DropdownAsyncVOCReason from "components/Common/DropdownAsyncVOCReason";
import ModalMultiPreviewImage from "components/Common/ModalMultiPreviewImage";
import { ROLES_FOR_APP } from "helpers/role";
import TooltipCustom from "components/Common/TooltipCustom";
import { Link } from "react-router-dom";
import vocManaApi from "api/vocManaApi";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import ModalConfirm from "components/Common/ModalConfirm";


const TYPE_SELECT_DEFAULT: string = "created_at";

registerLocale("en", en);
registerLocale("ko", ko);

const VOCList = () => {
  const { t, i18n } = useTranslation();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    type: withDefault(NumberParam, null),
    vocReasonId: withDefault(NumberParam, null),
    startDate: withDefault(StringParam, ""),
    endDate: withDefault(StringParam, ""),
    // sortBy: withDefault(StringParam, "createdAt"),
    // orderBy: withDefault(StringParam, "desc"),
  });

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.startDate
      ? moment(query?.startDate || "", "Y-MM-DD").toDate()
      : null,
    query?.endDate ? moment(query?.endDate || "", "Y-MM-DD").toDate() : null,
  ]);
  const [startDate, endDate] = dateSearch;

  const [reasonSearch, setReasonSearch] = useState<any>({
    label: t("All Filter"),
    value: "all",
  });

  const [vocTypeSearch, setVOCTypeSearch] = useState<any>(
    LIST_VOC_TYPE_OPTION?.find(
      (item) => item?.value === query?.type
    )?.value || ""
  );

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.VOCList;
  const RewardsProperties = createSelector(selectLayoutState, (state) => ({
    vocList: state.vocList,
    isVOCListLoading: state.isVOCListLoading,
    isVOCListSuccess: state.isVOCListSuccess,
    error: state.error,
  }));

  // Inside your component
  const { vocList, isVOCListLoading } = useSelector(RewardsProperties);
  const [linkImage, setLinkImage] = useState<any>(null);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);

  function loadTableData() {
    dispatch(getVOCList(query));
  }

  const searchData = () => {
    setQuery({
      ...query,
      type: vocTypeSearch || '',
      vocReasonId: reasonSearch?.value || '',
      startDate: startDate
        ? formatDateStringToUTC(
          moment(new Date(startDate))
            .startOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      endDate: endDate
        ? formatDateStringToUTC(
          moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss")
        )
        : "",
      sortBy: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        type: null,
        vocReasonId: null,
        startDate: "",
        endDate: "",
        sortBy: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );
    setReasonSearch({
      label: t("All Filter"),
      value: "all",
    });
    setVOCTypeSearch((_prev: any) => "");
    setDateSearch([null, null]);
  };

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        Cell: ({ ...props }) => {
          return (
            <div style={{ minWidth: "50px" }}>
              {vocList?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t('VOC Type'),
        accessor: "reason",
        thClass: "text-center whitespace-nowrap",
        thWidth: 140,
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const typeId = cell?.value?.type;

          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_VOC_TYPE[typeId] || "secondary"
                  }`}
              >
                {t(
                  LIST_VOC_TYPE_OPTION?.find(
                    (item: any) => item?.value === typeId
                  )?.label || "-"
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t('User Type'),
        accessor: "user.type",
        thClass: "text-center whitespace-nowrap",
        thWidth: 140,
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const userType = cell?.value;

          return (
            <div className="text-center" style={{ minWidth: 100 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_RESERVATION_USER_TYPE[userType] || "secondary"
                  }`}
              >
                {t(
                  RESERVATION_USER_TYPE?.find(
                    (item: any) => item?.value === userType
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Reason"),
        accessor: "ReasonName",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 250,
        Cell: (cell: any) => {
          const reason = cell?.row?.original?.reason;
          const name = i18n?.language === 'en' ? reason?.reasonEn : reason?.reasonKr;

          return name ? (
            <div style={{ minWidth: '200px' }}>
              <CopyWrapper contentCopy={name}>
                {truncate(name, 70)}
              </CopyWrapper>
            </div>
          ) : "-";
        },
      },
      {
        Header: t("Detail Reason"),
        accessor: "content",
        filterable: true,
        sortable: false,
        thWidth: 180,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const name = cell?.value;

          return name ? (
            <CopyWrapper contentCopy={name} style={{ minWidth: "100px" }}>
              <CollapseContent
                style={{ maxWidth: "120px" }}
                dataOriginal={name}
                isRank={false}
                isInlineBlock={true}
                isShowModal={true}
                numberCharactor={60}
                titleModal={t("Content")}
              />
            </CopyWrapper>
          ) : '-';
        },
      },
      {
        Header: t("Photo"),
        accessor: "user.profile.imageUrls",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 80,
        Cell: (cell: any) => {
          const images = cell?.value;
          return (
            <div className="w-100 text-center " style={{ minWidth: "60px" }}>
              <div
                style={{ width: "45px" }}
                className="m-auto cursor-pointer"
                onClick={() => setLinkImage({ urls: images?.length > 0 && images })}
              >
                <img
                  src={images?.[0] ?? NO_IMAGE_USER}
                  className="rounded-circle avatar-sm"
                  alt="thumbnail"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = NO_IMAGE_USER;
                  }}
                />
              </div>
            </div>
          )
        },
      },
      {
        Header: t("Nickname"),
        accessor: "user.profile.nickname",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const nickname = cell?.value;

          return (
            nickname ? (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={nickname}>
                  {`${nickname}`}
                </CopyWrapper>
              </div>
            ) : "-"
          );
        },
      },
      {
        Header: t("Email Profile"),
        accessor: "profile.email",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const email = cell?.row?.original?.user?.profile?.email;
          return (
            email ? (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={email}>
                  {`${email}`}
                </CopyWrapper>
              </div>
            ) : "-"
          );
        },
      },
      {
        Header: t("Email SNS"),
        accessor: "user.email",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const email = cell?.value;
          return (
            email ? (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={email}>
                  {`${email}`}
                </CopyWrapper>
              </div>
            ) : "-"
          );
        },
      },
      {
        Header: t("Created at"),
        accessor: "createdAt",
        filterable: true,
        sortable: false,
        thWidth: 120,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t('Action'),
        thClass: 'text-center',
        thWidth: 100,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '70px' }}>
                <TooltipCustom
                  title={t('Button Delete VOC List')}
                  id={`detail-cp-${item?.id}`}
                >
                  <Link
                    className="btn btn-sm btn-soft-danger edit-item-btn"
                    to="#"
                    onClick={(e: any) => {
                      e.preventDefault();
                      setItemToDelete(item);
                    }}
                  >
                    <i className="ri-delete-bin-3-fill align-bottom"></i>
                  </Link>
                </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, vocList?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  // Begin::Delete
  const handleActionDelete = async (id: any) => {
    if (!id) return;

    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await vocManaApi.deleteVOCList(id);
      if (response?.code) {
        setIsConfirmLoading((_prev) => false);
        dispatch(getVOCList(query));
        setItemToDelete(false);
        toast(
          `${t("The VOC has been deleted.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };
  // End::Delete

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    document.title = `${t("VOC List")} - ${t('Home')} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("VOC List")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-5 con-sm-6">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t('Total')}:</span>
                          <CountUp
                            start={0}
                            end={vocList?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>

                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-2 mt-3"
                      >
                        <LabelWrapper label={t("VOC Type")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={LIST_VOC_TYPE_OPTION || []}
                            placeholder={`${t("Select VOC type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={vocTypeSearch}
                            onChangeSelect={(e: any) =>
                              setVOCTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_VOC_TYPE}
                          />
                        </LabelWrapper>
                      </Col>


                      <Col
                        sm={12}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-2 mt-3"
                      >
                        <LabelWrapper label={t("Reason")} isShow={true}>
                          <DropdownAsyncVOCReason
                            name="voc-reason"
                            onChangeSelect={(event: any) => {
                              setReasonSearch(event);
                            }}
                            isMulti={false}
                            placeholder={`${t("Select reason")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedReason={reasonSearch}
                            keywordSearch={vocTypeSearch}
                            isClearable={false}
                            key={`${vocTypeSearch}-${i18n?.language}`}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-2 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-2 mt-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={vocList?.items?.length ? vocList?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={vocList?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(vocList?.pagination?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sortBy: query.sortBy,
                        orderBy: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isVOCListLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreviewImage
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          onClose={() => onCloseImageClick()}
        />

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete VOC List")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default VOCList;
